import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { settingsService } from '../services/api';
import './Dashboard.css';

const SchedulingRules: React.FC = () => {
  const { hostel } = useAuth();
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    billingDueDay: '5',
    reminderCadenceDays: '3',
    lateFeePerDay: '10',
    lateFeeCap: '500',
  });

  useEffect(() => {
    const run = async () => {
      if (!hostel?.id) return;
      setLoading(true);
      try {
        const rules = await settingsService.getBillingRules(hostel.id);
        setForm({
          billingDueDay: String(rules.billingDueDay ?? 5),
          reminderCadenceDays: String(rules.reminderCadenceDays ?? 3),
          lateFeePerDay: String(rules.lateFeePerDay ?? 10),
          lateFeeCap: String(rules.lateFeeCap ?? 500),
        });
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [hostel?.id]);

  const save = async () => {
    if (!hostel?.id) return;
    setLoading(true);
    try {
      await settingsService.updateBillingRules(hostel.id, {
        billingDueDay: Number(form.billingDueDay),
        reminderCadenceDays: Number(form.reminderCadenceDays),
        lateFeePerDay: Number(form.lateFeePerDay),
        lateFeeCap: Number(form.lateFeeCap),
      });
      alert('Rules saved');
    } finally {
      setLoading(false);
    }
  };

  if (!hostel) return <div className="loading-container">Loading...</div>;

  return (
    <div className="dashboard-container">
      <h1>Scheduling & Late Fee Rules</h1>
      <div className="form-container">
        <div className="form-row">
          <div className="form-group">
            <label>Billing due day (1-28)</label>
            <input value={form.billingDueDay} onChange={(e) => setForm({ ...form, billingDueDay: e.target.value })} />
          </div>
          <div className="form-group">
            <label>Reminder cadence days</label>
            <input
              value={form.reminderCadenceDays}
              onChange={(e) => setForm({ ...form, reminderCadenceDays: e.target.value })}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Late fee per day (₹)</label>
            <input value={form.lateFeePerDay} onChange={(e) => setForm({ ...form, lateFeePerDay: e.target.value })} />
          </div>
          <div className="form-group">
            <label>Late fee cap (₹)</label>
            <input value={form.lateFeeCap} onChange={(e) => setForm({ ...form, lateFeeCap: e.target.value })} />
          </div>
        </div>

        <button className="btn btn-primary" onClick={save} disabled={loading}>
          Save
        </button>

        {loading && <div className="loading-container">Loading...</div>}
      </div>
    </div>
  );
};

export default SchedulingRules;

